import { useState } from 'react'
import { Eye } from 'lucide-react'

import { Button } from '@/common/ui/button'
import InvoiceSummaryModal from '../../../../InvoiceSummaryModal'
import type { CryptoInvoiceData } from '../../../../../type'

interface ViewSummaryButtonProps {
	invoice: CryptoInvoiceData
}

export default function ViewSummaryButton({ invoice }: ViewSummaryButtonProps) {
	const [open, setOpen] = useState(false)

	// Don't show button if no billing month
	if (!invoice.billingMonth) {
		return null
	}

	return (
		<>
			<Button
				variant="ghost"
				size="sm"
				onClick={() => setOpen(true)}
				className="gap-1"
			>
				<Eye className="h-4 w-4" />
				ดูสรุป
			</Button>

			<InvoiceSummaryModal
				open={open}
				onOpenChange={setOpen}
				billingMonth={invoice.billingMonth}
				invoiceAmount={invoice.amount}
				invoiceType={invoice.invoiceType}
			/>
		</>
	)
}
